import { analytics } from 'Modules/Analytics'
import { DocumentType } from 'Generated/resilia-search-graphql-types'

/* eslint-disable @typescript-eslint/no-empty-interface */
const config = { domain: 'Home' }

interface NavigationItemClicked {}

interface InitiativesGoalTitleClicked {
  initiativeId: number
  goalId: number
}

interface InitiativesAddDataClicked {
  goalId: number
  initiativeId: number
}

interface InitiativesCreateNewGoalClicked {
  initiativeId: number
}

// TODO: Remove this event once the Chart Wizard is released without the FF 'showGoalWizard'
interface InitiativesAddMeasurementClicked {
  goalId: number
  initiativeId: number
}

interface InitiativesGoalSelected {
  goalId: number
}

interface DonationsClicked {
  userID: number
  nonprofitOrgID: number
}

interface ChevronClicked {}

interface InitiativesGoalTaskCompleted {
  assigneeUserEmail: string
  taskId: number
  taskDescription: string
  taskStatus: string
  taskUpdatedDate: string
  userId: number
  goalId: number
  initiativeId: number
  templateLibraryId: number
  goalType: string
}

interface InitiativesStartCTAClicked {}

interface InviteTeamCTAClicked {}

interface UpdateAccountSettingsCTAClicked {}

interface StorytellingStartCTAClicked {}

interface StoriesStoryTitleClicked {}

interface StoriesViewAllStoriesClicked {}

interface StoriesShareStoryCTAClicked {
  storyId: number
}

interface StoriesCopyPublicLinkClicked {
  storyId: number
}

interface StoriesShareToSocialPlatformClicked {
  platformName: 'LinkedIn' | 'Twitter' | 'Facebook' | 'Eamil'
}

interface StoriesPaginationForwardClicked {}

interface StoriesPaginationBackwardClicked {}

interface StoriesTitleChevronClicked {}

interface FunderFinderTitleChevronClicked {}

interface FunderFinderSavedFundersPaginationClicked {}

interface FunderFinderSavedFundersStartCTAClicked {}

interface FunderFinderViewedFundersStartCTAClicked {}

interface FunderFinderTabClicked {
  tab: 'Saved' | 'Recently-Viewed'
}

interface FunderFinderProfileClicked {
  profileId: number
}
interface FunderFinderStartCTAClicked {}
interface AcademyStartCourseClicked {
  courseId: string
  courseTitle: string
  topidId: string
}

interface AcademyResumeCourseClicked {
  courseId: string
  courseTitle: string
  topidId: string
}

interface AcademyReviewCourseClicked {
  courseId: string
  courseTitle: string
  topidId: string
}

interface AcademyFeaturedClicked {
  resourceId: string
  resourceName: string
  resourceType: string
}

interface AcademyRecommendedClicked {
  resourceId: string
  resourceName: string
  resourceType: string
}

interface AcademyExploreAcademyClicked {
  option: string
}

interface UserDataPromptModalViewed {}

interface UserDataPromptModalSkipClicked {}

interface UserDataPromptModalPrivacyPolicyClicked {}

interface UserDataPromptModalTermsClicked {}

interface UserDataPromptThankYouMessageViewed {}

interface UserDataPromptModalSaveClicked {
  fieldsUpdated: string[]
}

interface UserDataPromptContinueToHomeClicked {}

interface SearchSearchResultClicked {
  url: string
  title: string
  documentId: string
  type: DocumentType
  query: string
}

interface InitiativesLinkClicked {
  taskId: number
  taskStatus: boolean
  taskUpdatedDate: string
  linkText: string
  linkUrl: string
}

interface InitiativesAcademyResourceClicked {
  taskId: number
  taskStatus: boolean
  taskUpdatedDate: string
  resourceId: string
}

interface CommunityEventClicked {
  eventName: string
  eventUrl: string
  eventTime: string
}

interface CommunityViewAllEventsClicked {}

interface NavigationLoadTracked {
  loadTime: number
}

interface NavigationItemsLoadTracked {
  loadTime: number
}

interface ObjectivesWidgetLoadTracked {
  loadTime: number
  isFirstLoad: boolean
}

interface AcademyWidgetLoadTracked {
  loadTime: number
  isFirstLoad: boolean
}

interface TasksWidgetLoadTracked {
  loadTime: number
  isFirstLoad: boolean
}

interface CommunityWidgetLoadTracked {
  loadTime: number
  isFirstLoad: boolean
}
interface AllWidgetsLoadTracked {
  loadTime: number
  isFirstLoad: boolean
}

export const home = {
  Clicked: {
    Clicked: (param: NavigationItemClicked) => param,
    config,
  },
  Initiatives_Goal_Title_Clicked: {
    Initiatives_Goal_Title_Clicked: (param: InitiativesGoalTitleClicked) =>
      param,
    config,
  },
  Initiatives_Add_Data_Clicked: {
    Initiatives_Add_Data_Clicked: (param: InitiativesAddDataClicked) => param,
    config,
  },
  Initiatives_Create_New_Goal_Clicked: {
    Initiatives_Create_New_Goal_Clicked: (
      param: InitiativesCreateNewGoalClicked
    ) => param,
    config,
  },
  // TODO: Remove this event once the Chart Wizard is released without the FF 'showGoalWizard'
  Initiatives_Add_Measurement_Clicked: {
    Initiatives_Add_Measurement_Clicked: (
      param: InitiativesAddMeasurementClicked
    ) => param,
    config,
  },
  Initiatives_Goal_Selected: {
    Initiatives_Goal_Selected: (param: InitiativesGoalSelected) => param,
    config,
  },
  Initiatives_View_All_Goals_Clicked: {
    Initiatives_View_All_Goals_Clicked: () => {
      // This function doesn't expect any params
    },
    config,
  },
  Initiatives_View_In_Objectives_Clicked: {
    Initiatives_View_In_Objectives_Clicked: () => {
      // This function doesn't expect any params
    },
    config,
  },
  Initiatives_Goal_Task_Completed: {
    Initiatives_Goal_Task_Completed: (param: InitiativesGoalTaskCompleted) =>
      param,
    config,
  },
  Initiatives_Title_Chevron_Clicked: {
    Initiatives_Title_Chevron_Clicked: (param: ChevronClicked) => param,
    config,
  },
  Initiatives_Start_CTA_Clicked: {
    Initiatives_Start_CTA_Clicked: (param: InitiativesStartCTAClicked) => param,
    config,
  },
  Initiatives_Link_Clicked: {
    Initiatives_Link_Clicked: (param: InitiativesLinkClicked) => param,
    config,
  },
  Initiatives_Academy_Resource_Clicked: {
    Initiatives_Academy_Resource_Clicked: (
      param: InitiativesAcademyResourceClicked
    ) => param,
    config,
  },
  Join_Community_Clicked: {
    Join_Community_Clicked: () => {
      // This function doesn't expect any params
    },
    config,
  },
  Visit_Community_Clicked: {
    Visit_Community_Clicked: () => {
      // This function doesn't expect any params
    },
    config,
  },
  Stories_Story_Title_Clicked: {
    Stories_Story_Title_Clicked: (param: StoriesStoryTitleClicked) => param,
    config,
  },
  Stories_Share_Story_CTA_Clicked: {
    Stories_Share_Story_CTA_Clicked: (param: StoriesShareStoryCTAClicked) =>
      param,
    config,
  },
  Stories_View_All_Clicked: {
    Stories_View_All_ClickedL: (param: StoriesViewAllStoriesClicked) => param,
    config,
  },
  Stories_Copy_Public_Link_Clicked: {
    Stories_Copy_Public_Link_Clicked: (param: StoriesCopyPublicLinkClicked) =>
      param,
    config,
  },
  Stories_Share_To_Social_Platform_Clicked: {
    Stories_Share_To_Social_Platform_Clicked: (
      param: StoriesShareToSocialPlatformClicked
    ) => param,
    config,
  },
  Stories_Pagination_Forward_Clicked: {
    Stories_Pagination_Forward_Clicked: (
      param: StoriesPaginationForwardClicked
    ) => param,
    config,
  },
  Stories_Pagination_Backward_Clicked: {
    Stories_Pagination_Backward_Clicked: (
      param: StoriesPaginationBackwardClicked
    ) => param,
    config,
  },
  Invite_Team_CTA_Clicked: {
    Invite_Team_CTA_Clicked: (param: InviteTeamCTAClicked) => param,
    config,
  },
  Update_Account_Settings_CTA_Clicked: {
    Update_Account_Settings_CTA_Clicked: (
      param: UpdateAccountSettingsCTAClicked
    ) => param,
    config,
  },
  Storytelling_Start_CTA_Clicked: {
    Storytelling_Start_CTA_Clicked: (param: StorytellingStartCTAClicked) =>
      param,
    config,
  },

  Stories_Title_Chevron_Clicked: {
    Stories_Title_Chevron_Clicked: (param: StoriesTitleChevronClicked) => param,
    config,
  },

  Funder_Finder_Start_CTA_Clicked: {
    Funder_Finder_Start_CTA_Clicked: (param: FunderFinderStartCTAClicked) =>
      param,
    config,
  },
  Funder_Finder_Title_Chevron_Clicked: {
    Funder_Finder_Title_Chevron_Clicked: (
      param: FunderFinderTitleChevronClicked
    ) => param,
    config,
  },

  Funder_Finder_Tab_Clicked: {
    Funder_Finder_Tab_Clicked: (param: FunderFinderTabClicked) => param,
    config,
  },
  Funder_Finder_Profile_Clicked: {
    Funder_Finder_Profile_Clicked: (param: FunderFinderProfileClicked) => param,
    config,
  },
  Funder_Finder_Saved_Funders_Start_CTA_Clicked: {
    Funder_Finder_Saved_Funders_Start_CTA_Clicked: (
      param: FunderFinderSavedFundersStartCTAClicked
    ) => param,
    config,
  },
  Funder_Finder_Viewed_Funders_Start_CTA_Clicked: {
    Funder_Finder_Viewed_Funders_Start_CTA_Clicked: (
      param: FunderFinderViewedFundersStartCTAClicked
    ) => param,
    config,
  },
  Funder_Finder_Saved_Funders_Pagination_Forward_Clicked: {
    Funder_Finder_Saved_Funders_Pagination_Forward_Clicked: (
      param: FunderFinderSavedFundersPaginationClicked
    ) => param,
    config,
  },
  Funder_Finder_Saved_Funders_Pagination_Backward_Clicked: {
    Funder_Finder_Saved_Funders_Pagination_Backward_Clicked: (
      param: FunderFinderSavedFundersPaginationClicked
    ) => param,
    config,
  },
  Funder_Finder_Viewed_Funders_Pagination_Forward_Clicked: {
    Funder_Finder_Viewed_Funders_Pagination_Forward_Clicked: (
      param: FunderFinderSavedFundersPaginationClicked
    ) => param,
    config,
  },
  Funder_Finder_Viewed_Funders_Pagination_Backward_Clicked: {
    Funder_Finder_Viewed_Funders_Pagination_Backward_Clicked: (
      param: FunderFinderSavedFundersPaginationClicked
    ) => param,
    config,
  },
  Academy_Start_Course_Clicked: {
    Academy_Start_Course_Clicked: (param: AcademyStartCourseClicked) => param,
    config,
  },
  Academy_Resume_Course_Clicked: {
    Academy_Resume_Course_Clicked: (param: AcademyResumeCourseClicked) => param,
    config,
  },
  Academy_Review_Course_Clicked: {
    Academy_Review_Course_Clicked: (param: AcademyReviewCourseClicked) => param,
    config,
  },
  Academy_Featured_Clicked: {
    Academy_Featured_Clicked: (param: AcademyFeaturedClicked) => param,
    config,
  },
  Academy_Recommended_Clicked: {
    Academy_Recommended_Clicked: (param: AcademyRecommendedClicked) => param,
    config,
  },
  Academy_Explore_Academy_Clicked: {
    Academy_Explore_Academy_Clicked: (param: AcademyExploreAcademyClicked) =>
      param,
    config,
  },
  Academy_Title_Chevron_Clicked: {
    Academy_Title_Chevron_Clicked: (param: ChevronClicked) => param,
    config,
  },
  User_Data_Prompt_Modal_Viewed: {
    User_Data_Prompt_Modal_Viewed: (param: UserDataPromptModalViewed) => param,
    config,
  },
  User_Data_Prompt_Modal_Skip_Clicked: {
    User_Data_Prompt_Modal_Skip_Clicked: (
      param: UserDataPromptModalSkipClicked
    ) => param,
    config,
  },
  User_Data_Prompt_Modal_Privacy_Policy_Clicked: {
    User_Data_Prompt_Modal_Privacy_Policy_Clicked: (
      param: UserDataPromptModalPrivacyPolicyClicked
    ) => param,
    config,
  },
  User_Data_Prompt_Modal_Terms_Clicked: {
    User_Data_Prompt_Modal_Terms_Clicked: (
      param: UserDataPromptModalTermsClicked
    ) => param,
    config,
  },
  User_Data_Prompt_Thank_You_Message_Viewed: {
    User_Data_Prompt_Thank_You_Message_Viewed: (
      param: UserDataPromptThankYouMessageViewed
    ) => param,
    config,
  },
  User_Data_Prompt_Modal_Save_Clicked: {
    User_Data_Prompt_Modal_Save_Clicked: (
      param: UserDataPromptModalSaveClicked
    ) => param,
    config,
  },
  User_Data_Prompt_Modal_Saved: {
    User_Data_Prompt_Modal_Saved: (param: UserDataPromptModalSaveClicked) =>
      param,
    config,
  },
  User_Data_Prompt_Continue_To_Home_Clicked: {
    User_Data_Prompt_Continue_To_Home_Clicked: (
      param: UserDataPromptContinueToHomeClicked
    ) => param,
    config,
  },
  Homepage_Donations_PreSetup_Clicked: {
    Homepage_Donations_PreSetup_Clicked: (param: DonationsClicked) => param,
    config,
  },
  Homepage_Donations_ResumeSetup_Clicked: {
    Homepage_Donations_ResumeSetup_Clicked: (param: DonationsClicked) => param,
    config,
  },
  Homepage_Donations_CustomizePortal_Clicked: {
    Homepage_Donations_CustomizePortal_Clicked: (param: DonationsClicked) =>
      param,
    config,
  },
  Homepage_Donations_HelpCenter_Clicked: {
    Homepage_Donations_HelpCenter_Clicked: (param: DonationsClicked) => param,
    config,
  },
  Homepage_Donations_ScheduleMeeting_Clicked: {
    Homepage_Donations_ScheduleMeeting_Clicked: (param: DonationsClicked) =>
      param,
    config,
  },
  Homepage_Donations_ViewAllCampaigns_Clicked: {
    Homepage_Donations_ViewAllCampaigns_Clicked: (param: DonationsClicked) =>
      param,
    config,
  },
  Search_Search_Result_Clicked:
    analytics.trackCreator<SearchSearchResultClicked>({
      ...config,
      eventName: 'Search_Search_Result_Clicked',
    }),
  Community_Event_Clicked: {
    Community_Event_Clicked: (param: CommunityEventClicked) => param,
    config,
  },
  Community_View_All_Events_Clicked: {
    Community_View_All_Events_Clicked: (param: CommunityViewAllEventsClicked) =>
      param,
    config,
  },
  Navigation_Load_Tracked: analytics.trackCreator<NavigationLoadTracked>({
    ...config,
    eventName: 'Navigation_Load_Tracked',
  }),
  Navigation_Items_Load_Tracked:
    analytics.trackCreator<NavigationItemsLoadTracked>({
      ...config,
      eventName: 'Navigation_Items_Load_Tracked',
    }),
  Academy_Widget_Load_Tracked: analytics.trackCreator<AcademyWidgetLoadTracked>(
    {
      ...config,
      eventName: 'Academy_Widget_Load_Tracked',
    }
  ),
  Tasks_Widget_Load_Tracked: analytics.trackCreator<TasksWidgetLoadTracked>({
    ...config,
    eventName: 'Tasks_Widget_Load_Tracked',
  }),
  Community_Widget_Load_Tracked:
    analytics.trackCreator<CommunityWidgetLoadTracked>({
      ...config,
      eventName: 'Community_Widget_Load_Tracked',
    }),
  All_Widgets_Load_Tracked: analytics.trackCreator<AllWidgetsLoadTracked>({
    ...config,
    eventName: 'All_Widgets_Load_Tracked',
  }),
}
